// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"108":"810ed289355706dcfe20","125":"3fa8f20f37bca922aad3","245":"20919107401fed5a92db","452":"c0ff3ab48c1cc3cab85a"}[chunkId] + ".js";
};